import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EVSEChecklist from './EVSEChecklist';
import EVSEForm from './EVSEForm';
import { LOCATION_REQUIRED_FIELDS, LOCATION_FIELD_GROUPS } from '../config/evseFields';

const API = 'https://api.cpms-srlkevcharge.com';

export default function WizardStepLocation({
  organisationMode, setOrganisationMode,
  organisationId, setOrganisationId,
  organisationName, setOrganisationName,
  selectedFields, setSelectedFields,
  formData, setFormData,
  errors, setErrors
}) {
  const [organisations, setOrganisations] = useState([]);

  useEffect(() => {
    axios.get(`${API}/organisations/`)
      .then(res => setOrganisations(res.data))
      .catch(() => {});
  }, []);

  const toggleField = (name) => {
    setSelectedFields(prev =>
      prev.includes(name) ? prev.filter(f => f !== name) : [...prev, name]
    );
    if (selectedFields.includes(name)) {
      setFormData(prev => {
        const copy = { ...prev };
        delete copy[name];
        return copy;
      });
    }
  };

  const selectAllInGroup = (names) => {
    setSelectedFields(prev => Array.from(new Set([...prev, ...names])));
  };

  const clearAllInGroup = (names) => {
    setSelectedFields(prev => prev.filter(f => !names.includes(f)));
    setFormData(prev => {
      const copy = { ...prev };
      names.forEach(n => delete copy[n]);
      return copy;
    });
  };

  const handleFieldChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };

  return (
    <>
      {/* ── Organisation Selector ── */}
      <div className="org-selector-card">
        <div style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--navy)', marginBottom: 12 }}>
          Which organisation is this for? <span className="required">*</span>
        </div>
        <div className="org-selector-toggle">
          <button
            type="button"
            className={organisationMode === 'existing' ? 'active' : ''}
            onClick={() => setOrganisationMode('existing')}
          >
            Select Existing
          </button>
          <button
            type="button"
            className={organisationMode === 'new' ? 'active' : ''}
            onClick={() => setOrganisationMode('new')}
          >
            Create New
          </button>
        </div>

        {organisationMode === 'existing' ? (
          <select
            value={organisationId || ''}
            onChange={(e) => setOrganisationId(e.target.value)}
            style={errors.organisation ? { borderColor: 'var(--red)' } : {}}
          >
            <option value="">Select an organisation...</option>
            {organisations.map(org => (
              <option key={org.id} value={org.id}>{org.name}</option>
            ))}
          </select>
        ) : (
          <input
            type="text"
            placeholder="e.g. Test Hotels Ltd"
            value={organisationName}
            onChange={(e) => setOrganisationName(e.target.value)}
            style={errors.organisation ? { borderColor: 'var(--red)' } : {}}
          />
        )}
        {errors.organisation && (
          <span className="hint" style={{ color: 'var(--red)', display: 'block', marginTop: 6 }}>
            {errors.organisation}
          </span>
        )}
      </div>

      {/* ── Location Checklist + Form ── */}
      <div className="evse-builder">
        <EVSEChecklist
          groups={LOCATION_FIELD_GROUPS}
          selectedFields={selectedFields}
          onToggle={toggleField}
          onSelectAllInGroup={selectAllInGroup}
          onClearAllInGroup={clearAllInGroup}
        />
        <EVSEForm
          title="Location Details"
          requiredFields={LOCATION_REQUIRED_FIELDS}
          groups={LOCATION_FIELD_GROUPS}
          selectedFields={selectedFields}
          formData={formData}
          onChange={handleFieldChange}
          errors={errors}
          emptyHint="Tick a box on the left to add more details about this location."
        />
      </div>
    </>
  );
}